module.exports = __webpack_public_path__ + "img/app_store.63249361.svg";